import { useEffect, useMemo, useRef, useState } from "react";
import Utils from "@utils/utils";
import Iconfont from "@utils/Iconfont";
import styles from "./index.module.scss";

const RefImageStrip = ({ images = [], selectedInputImg, setSelectedInputImg }) => {
    const listRef = useRef(null);
    const [showSwitchBtn, setShowSwitchBtn] = useState(false);

    const normalizedImages = useMemo(() => {
        return (images || [])
            .map((img) => img?.url || img)
            .filter(Boolean);
    }, [images]);

    const currentIndex = useMemo(() => {
        const matchedIndex = normalizedImages.findIndex((url) => url === selectedInputImg);
        return matchedIndex >= 0 ? matchedIndex : 0;
    }, [normalizedImages, selectedInputImg]);

    const handleSwitch = (direction) => {
        if (normalizedImages.length <= 1) return;

        const nextIndex = direction === "prev"
            ? (currentIndex - 1 + normalizedImages.length) % normalizedImages.length
            : (currentIndex + 1) % normalizedImages.length;

        setSelectedInputImg?.(normalizedImages[nextIndex]);
    };

    useEffect(() => {
        const el = listRef.current;
        if (!el) return;

        const updateOverflowState = () => {
            setShowSwitchBtn(el.scrollWidth > el.clientWidth + 1);
        };

        updateOverflowState();

        const resizeObserver = new ResizeObserver(() => {
            updateOverflowState();
        });

        resizeObserver.observe(el);
        window.addEventListener("resize", updateOverflowState);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener("resize", updateOverflowState);
        };
    }, [normalizedImages]);

    if (!normalizedImages.length) return null;

    return (
        <div className={styles.RefImageStrip}>
            {showSwitchBtn && (
                <button
                    type="button"
                    className={styles.SwitchBtn}
                    onClick={() => handleSwitch("prev")}
                >
                    <Iconfont type="icon-LeftOutlined" />
                </button>
            )}
            <div ref={listRef} className={`${styles.List} _beauty_scrollbar`}>
                {normalizedImages.map((url, index) => (
                    <div
                        key={`${url}-${index}`}
                        className={`${styles.Item} ${selectedInputImg === url ? styles.ItemActive : ""}`}
                        onClick={() => setSelectedInputImg?.(url)}
                    >
                        <img src={Utils.getImgThumbnail(url)} alt="" />
                    </div>
                ))}
            </div>
            {showSwitchBtn && (
                <button
                    type="button"
                    className={styles.SwitchBtn}
                    onClick={() => handleSwitch("next")}
                >
                    <Iconfont type="icon-RightOutlined" />
                </button>
            )}
        </div>
    );
};

export default RefImageStrip;
